import { render, staticRenderFns } from "./eventTag2.vue?vue&type=template&id=cde5699c&scoped=true"
import script from "./eventTag2.vue?vue&type=script&lang=js"
export * from "./eventTag2.vue?vue&type=script&lang=js"
import style0 from "./eventTag2.vue?vue&type=style&index=0&id=cde5699c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde5699c",
  null
  
)

export default component.exports